import { render, staticRenderFns } from "./PosteMatchingReport.vue?vue&type=template&id=201809ef&scoped=true&"
import script from "./PosteMatchingReport.vue?vue&type=script&lang=ts&"
export * from "./PosteMatchingReport.vue?vue&type=script&lang=ts&"
import style0 from "./PosteMatchingReport.vue?vue&type=style&index=0&id=201809ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201809ef",
  null
  
)

export default component.exports